import React from "react";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

function Footer() {
  const { locale } = useRouter();
  const { t, ready } = useTranslation("common");

  return (
    <footer className="bg-[#fff] shadow-lg py-10 text-[14px]">
      <div className="flex flex-col max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-[#7C7C7C] flex gap-x-1">
          <Image
            src={
              locale === "de"
                ? "logo/fotoboxguru-color-logo.svg"
                : "logo/boothscanner-logo.svg"
            }
            width={220}
            height={100}
            alt={locale === "de" ? "FotoboxGuru Logo" : "BoothScanner Logo"}
          />
        </div>

        {/* ✅ Flexbox für gleichmäßige Verteilung auf Desktop */}
        <div className="flex flex-col md:flex-row md:justify-between gap-5 mt-3">
          {locale === "de" && (
            <div className="flex flex-col gap-1">
              <span className="text-[16px] font-semibold">Für Partner</span>
              <Link
                href="https://partner.fotoboxguru.de/"
                target="_blank"
                className="text-[#C0C0C0] hover:underline"
                rel="nofollow"
              >
                Fotobox-Partner Login
              </Link>
              <Link
                href="/affiliate-partner-werden"
                target="_blank"
                className="text-[#C0C0C0] hover:underline"
                rel="nofollow"
              >
                Affiliate-Partner werden
              </Link>
            </div>
          )}

          <div className="flex flex-col gap-1">
            {locale === "de" && (
              <span className="text-[16px] font-semibold">
                {t("footer.links")}
              </span>
            )}
            {ready && (
              <>
                <Link
                  href={`/${t("footer.privacy")
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                  className="text-[#C0C0C0] hover:underline"
                  rel="nofollow"
                >
                  {t("footer.privacy")}
                </Link>
                {locale === "de" && (
                  <Link
                    href={`/${t("footer.agb").toLowerCase()}`}
                    className="text-[#C0C0C0] hover:underline"
                    rel="nofollow"
                  >
                    {t("footer.agb")}
                  </Link>
                )}
                <Link
                  href={`/${t("footer.imprint")
                    .toLowerCase()
                    .replace(/\s+/g, "-")}`}
                  className="text-[#C0C0C0] hover:underline"
                  rel="nofollow"
                >
                  {t("footer.imprint")}
                </Link>
              </>
            )}
          </div>

          {locale === "de" && (
            <div className="flex flex-col bg-[#f9f9f9] p-4 rounded-md gap-3">
              <div>
                <span className="text-[16px] font-semibold">
                  Zahlungsmöglichkeiten
                </span>
              </div>
              <div className="flex flex-row justify-start gap-5">
                <Image
                  src="images/paymentLogoVisa.svg"
                  alt="Visa"
                  width={50}
                  height={50}
                />
                <Image
                  src="images/paymentLogoMasterCard.svg"
                  width={30}
                  height={30}
                  alt="MasterCard"
                />
                <Image
                  src="images/paymentLogoKlarna.svg"
                  width={50}
                  height={50}
                  alt="Klarna"
                />
                <Image
                  src="images/paymentLogoPayPal.svg"
                  width={70}
                  height={70}
                  alt="PayPal"
                />
              </div>
              <span className="text-[#C0C0C0] text-[14px]">
                Bei Buchung/Zahlung über FotoboxGuru.de.
              </span>
            </div>
          )}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
